/* eslint camelcase: 0 */
import { TalkTalker } from '@/infrastructure/network/Monitaro/schema/models'
import { ITalkerProps, EmptyTalkerPropsFactory } from '@/entities/Talker'
import RoomTalker from '@/infrastructure/network/Monitaro/schema/models/RoomTalker'

export const toTalkerProps = (props: TalkTalker | null | undefined, type?: string): ITalkerProps => {
  if (!props) {
    return EmptyTalkerPropsFactory()
  }

  const { id, fullname, organization, icon } = props

  return EmptyTalkerPropsFactory({
    id,
    fullname,
    organization,
    icon,
    type
  })
}

export const toRoomTalkerProps = (props: RoomTalker | null | undefined, type?: string): ITalkerProps => {
  if (!props) {
    return EmptyTalkerPropsFactory()
  }

  const { id, fullname, organization, icon } = EmptyTalkerPropsFactory(props.talker)

  return EmptyTalkerPropsFactory({
    id,
    fullname,
    organization,
    icon,
    type
  })
}
